import type { PropType } from 'vue'

export const definePropType = <T>(val: any): PropType<T> => val
